import styled from 'styled-components';
import { color } from '@magalu/stereo-ui-styles';
import { layout, space, typography } from 'styled-system';
import LinkComp from '../../atoms/Link';
export const MenuBox = styled.div.attrs(props => Object.assign({
  bg: 'background.white'
}, props))`
  border-bottom: ${props => props.borderColor ? `5px solid ${props.borderColor}` : ''};
  max-height: fit-content;
  width: fit-content;
  ${color}
`;
export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
`;
export const LinksWrapper = styled.div.attrs(props => Object.assign({
  p: 3
}, props))`
  display: flex;
  flex-direction: column;
  ${space}
`;
export const BannerWrapper = styled.div.attrs(props => Object.assign({
  m: 3
}, props))`
  /* let external project to define banner's width */
  ${layout}
  ${space}
`;
export const LinksList = styled.ul`
  display: inline-grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(${props => props.lines}, auto);
`;
export const LinkItem = styled.li.attrs(props => Object.assign({
  mr: 5
}, props))`
  list-style: none;
  line-height: 24px;
  ${space}
`;
export const Link = styled(LinkComp)``;
export const SubsectionTitle = styled.li.attrs(props => Object.assign({
  color: 'primary.base',
  fontSize: 1,
  fontWeight: 'bold',
  px: 2
}, props))`
  list-style: none;
  line-height: 24px;
  ${color}
  ${typography}
  ${space}
`;